import { render } from "./InvoicesTable.vue?vue&type=template&id=8e4a234e&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"

import "./InvoicesTable.vue?vue&type=style&index=0&id=8e4a234e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4a234e"]])

export default __exports__